import { $format } from './format';

export function parseCSV(data: string, delimiter: string = ',') {
    const pattern = new RegExp(
        // Delimiters.
        '(\\' + delimiter + '|\\r?\\n|\\r|^)' +

        // Quoted fields.
        '(?:"([^"]*(?:""[^"]*)*)"|' +

        // Standard fields.
        '([^"\\' + delimiter + '\\r\\n]*))', 'gi'
    );

    const array: string[][] = [];
    let row: string[] = [];

    let matches: RegExpExecArray | null = null;

    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while(matches = pattern.exec(data)) {
        let matched_delimiter = matches[1];

        if(matched_delimiter.length && matched_delimiter !== delimiter) { //row delimiter
            array.push(row);
            row = [];
        }

        row.push(matches[2] ? matches[2].replace(/""/, '"') : matches[3]);
    }

    if(row.length)
        array.push(row);

    return array;
}

const csv_must_quote = /[" ,]/;
const csv_must_escape = /"/g;

export function makeCSV(data: (string | number)[][], num_formatter?: (num: number) => string) {
    let result = '';

    for(const row of data) {
        result += row.map((col) => {
            if(typeof col == 'number') {
                if(num_formatter)
                    col = num_formatter(col);
                else
                    col = $format.maxNumber(col, 3);
            }

            return csv_must_quote.test(col) ? '"' + col.replace(csv_must_escape, '""') + '"' : col
        }).join(',') + '\n';
    }

    return result;
}
